import { createApp } from 'vue';
// Styles.
import './scss/app.scss';
// Scripts.
import parallax from './js/utils/parallax';
import './js/utils/buttonAnimation';
import './js/utils/continuousLoopLinkAnimation';
import './js/utils/forms';
import './js/utils/webform-floating-labels';
import './js/utils/header-sticky';
import './js/utils/gradient';
import './js/utils/rotate';
import './js/utils/scrollbar';
import './js/utils/statusMessages';
import './js/utils/titleArea';
import initScrollReveal from './js/utils/scrollReveal';

import './js/elements/business-card';

import "./js/paragraphs/accordion";
import './js/paragraphs/tabs';
import './js/paragraphs/video';
import './js/blocks/aboutMe';
import Questionnaire from './js/components/Questionnaire.vue';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => parallax());
} else {
  parallax();
}

initScrollReveal();

// Vue components.
if (document.querySelector('#questionnaire')) {
  const container = document.querySelector('#questionnaire');

  const app = createApp({
    data() {
      return {};
    },
  });

  app.component('Questionnaire', Questionnaire);
  app.mount('#questionnaire');
}

// Example init of a Vue app.
/* if (document.querySelector('#selector')) {
  const app = createApp({
    data() {
      return {};
    },
  });
  app.component('Name', ComponentInstance);
  app.mount('#selector');
} */
